export const BRAZILIAN_STATES = {
    AC: "Acre",
    AL: "Alagoas",
    AP: "Amapá",
    AM: "Amazonas",
    BA: "Bahia",
    CE: "Ceará",
    DF: "Distrito Federal",
    ES: "Espírito Santo",
    GO: "Goiás",
    MA: "Maranhão",
    MT: "Mato Grosso",
    MS: "Mato Grosso do Sul",
    MG: "Minas Gerais",
    PA: "Pará",
    PB: "Paraíba",
    PR: "Paraná",
    PE: "Pernambuco",
    PI: "Piauí",
    RJ: "Rio de Janeiro",
    RN: "Rio Grande do Norte",
    RS: "Rio Grande do Sul",
    RO: "Rondônia",
    RR: "Roraima",
    SC: "Santa Catarina",
    SP: "São Paulo",
    SE: "Sergipe",
    TO: "Tocantins",
};
export const BRAZILIAN_STATE_OPTIONS = Object.entries(BRAZILIAN_STATES)
    .map(([value, label]) => ({ value, label }))
    .sort((a, b) => a.label.localeCompare(b.label, "pt-BR"));
const withoutDiacritics = (text) => text
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .toLowerCase();
export function matchStateCode(state) {
    const raw = state?.trim();
    if (!raw)
        return null;
    const code = raw.toUpperCase();
    if (BRAZILIAN_STATES[code])
        return code;
    const target = withoutDiacritics(raw);
    const found = Object.entries(BRAZILIAN_STATES).find(([, name]) => withoutDiacritics(name) === target);
    return found ? found[0] : null;
}
export function normalizeStateCode(state) {
    const raw = state?.trim();
    if (!raw)
        return null;
    return matchStateCode(raw) ?? raw.toUpperCase();
}
export function stateLabel(code) {
    return BRAZILIAN_STATES[code] ?? code;
}
